import { createContext } from 'react';
import type { SlopeKeycloak } from '../core/index.js';

export interface KeycloakContextValue {
  keycloak: SlopeKeycloak | null;
  isInitialized: boolean;
  isAuthenticated: boolean;
}

export const KeycloakContext = createContext<KeycloakContextValue>({
  keycloak: null,
  isInitialized: false,
  isAuthenticated: false,
});
